// extracted by mini-css-extract-plugin
export default {"recent-transfers":"recent-transfers_recent-transfers__PH0JL"};